import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Killmoe Kush · Your Source for Cannabis Insights</p>
        <h1>Stay Informed on Cannabis Policy and Culture</h1>
        <p className="lede">
          Explore the latest updates on cannabis laws, policy changes, and cultural insights in your area. 
          Our mission is to provide comprehensive coverage and educational resources to keep you informed.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated with the latest changes in cannabis legislation and regulations affecting your community.
          </p>
        </article>
        <article>
          <h2>Cannabis Culture Insights</h2>
          <p>
            Discover articles and features that delve into the cultural aspects of cannabis, from art to advocacy.
          </p>
        </article>
        <article>
          <h2>Educational Guides</h2>
          <p>
            Access a variety of resources designed to educate you about cannabis, its uses, and its impact on society.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;